import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const CustomSuggestionItem = ({ value, placeholder }) => {
    const wrapperClassNames = classNames('display-flex align-items-center padding-top-5 padding-bottom-5', !value && 'text-color-gray');
    const iconClassNames = classNames('margin-left--5 margin-right-5 margin-top--1 rioglyph', value ? 'rioglyph-plus' : 'rioglyph-arrow-up');
    return (_jsxs("span", Object.assign({ className: wrapperClassNames }, { children: [_jsx("span", { className: iconClassNames }), _jsx("span", Object.assign({ className: 'text-italic' }, { children: value || placeholder }))] })));
};
export default CustomSuggestionItem;
